import { render, staticRenderFns } from "./OwnerNoteActions.vue?vue&type=template&id=610fa7f0&"
import script from "./OwnerNoteActions.vue?vue&type=script&lang=js&"
export * from "./OwnerNoteActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports